module.exports = __webpack_public_path__ + "img/icon-paper.69a8c2e9.svg";